module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-19-5bc26df0f8b571915e1fceeddcc228b1.svg";